<template>
    <div class="geoCentent">
        <div class="geoBox" id="geoBox"></div>
        <div class="tipBox">
            <div class="tab"></div>
            <div class="tabText">
                <span>0分</span>
                <span>10分</span>
            </div>
        </div>
    </div>
</template>
<script>
    import echarts from 'echarts';
    export default {
        props: {
            mapList: Array
        },
        data () {
            return {
                geoChart: null,
                mapdata: [],
                option: null,
  
                regionName: this.$store.state.integrity.userInfo
                    ? this.$store.state.integrity.userInfo.name
                    : '',
                regionCode: this.$store.state.integrity.userInfo
                    ? this.$store.state.integrity.userInfo.regionCode
                    : ''

            };
        },
        watch: {
            mapList: {
                handler (newValue, oldValue) {
                     this.setMapData({name:this.regionName,regionCode:this.regionCode})
                },
                deep: true
            }
        },
        mounted () {
            // 地图容器
            this.geoChart = echarts.init(document.getElementById('geoBox'));
            this.initChartOption();
            // 绘制地图
            this.refreshMapChart();
            // 初始化地图点击事件
            // this.initChartEvent();
            this.$on('cityValue', val => {
                // 下拉选择选项事件的选项
                this.regionName = val.name;
                this.regionCode = val.cityCode;
            });

            this.$on("refreshMap",()=>{
                // setTimeout(() => {
                //     this.refreshMapChart();
                // }, 2000);
            });
            // this.geoChart.on("click",()=>{
            //     this.geoChart.dispatchAction({
            //         type: 'downplay'
            //     });
            // })
        },
        methods: {
            // 刷新地图数据
            refreshMapChart () {
                this.setMapData({name:this.regionName,regionCode:this.regionCode})
            },
            // 初始化配置
            initChartOption () {
                // 初始化绘制全国地图配置
                this.option = {
                    backgroundColor: '#fff',
                    title: {
                        show: false,
                        text: 'Echarts3 云南地图下钻至县级',
                        subtext: '三级下钻',
                        left: 'center',
                        textStyle: {
                            color: '#000',
                            fontSize: 16,
                            fontWeight: 'normal',
                            fontFamily: 'Microsoft YaHei'
                        },
                        subtextStyle: {
                            show: false,
                            color: '#000',
                            fontSize: 13,
                            fontWeight: 'normal',
                            fontFamily: 'Microsoft YaHei'
                        }
                    },
                    tooltip: {
                        // 点击显示
                        trigger: 'item',
                        backgroundColor: 'rgba(54,54,54,1)',
                        formatter: function (param) {
                            return isNaN(param.value)
                                ? param.name
                                : param.name + ':' + param.value;
                        },
                        textStyle:{
                            fontSize:12
                        }
                    },
                    visualMap: {
                        show: false,
                        type: 'continuous',
                        text: ['', ''],
                        showLabel: false,
                        orient: 'horizontal',
                        right: '5',
                        barWidth: '2',
                        min: 0,
                        max: 10,
                        inRange: {
                            color: [
                                'rgba(185, 223, 201, 1)',
                                'rgba(54, 179, 116, 1)'
                            ]
                        },
                        splitNumber: 0,
                        textStyle: {
                            color: '#000'
                        }
                    },
                    animationDuration: 1000,
                    animationEasing: 'cubicOut',
                    animationDurationUpdate: 1000
                };
            },
            // 渲染地图
            renderMap (map, data) {
                this.option.series = [
                    {
                        type: 'map',
                        roam: false,
                        mapType: map,
                        nameMap: {
                            china: '中国'
                        },
                        label: {
                            normal: {
                                show: false,
                                textStyle: {
                                    color: '#fff',
                                    fontSize: 13
                                }
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    color: '#fff',
                                    fontSize: 10
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                areaColor: 'rgba(185, 223, 201, 1)',
                                borderColor: "#fff",
                            },
                            emphasis: { 
                                areaColor: '#188950',
                                // areaColor:"rgba(241, 158, 64, 1)",
                                borderColor: "#fff",
                            }
                        },
                        zoom: 1, // 当前视角的缩放比例
                        aspectScale: 1, // 参数用于scale地图的长宽比
                        data: data
                    }
                ];
                this.geoChart.setOption(this.option);
                console.log('已刷新地图');
            },
            initChartEvent () {
                // 地图点击事件
                let that = this;
                this.geoChart.on('click', function (params) {
                    that.setMapData(params);
                });
            },
            // 配备地图数据
            setMapData (param) {
                let data;
                try {
                    data = require('../assets/geoJson/map/city/' +
                        param.regionCode +
                        '.json');
                    this.mapdata = [];
                    let maxArr=[];
                    for (var i = 0; i < data.features.length; i++) {
                        this.mapList.forEach(item => {
                            if (item.name == data.features[i].properties.name) {
                                maxArr.push(item.value)
                                this.mapdata.push({
                                    name: data.features[i].properties.name,
                                    value:Number(item.value).toFixed(2)
                                });
                            }
                        });
                    }
                    let max = Math.max(...maxArr);
                    this.option.visualMap.max = max + 5;
                } catch (error) {
                    console.log('地图获取不到json文件');
                }
                if (!data) {
                    return;
                }
                echarts.registerMap(param.name, data);
                this.renderMap(param.name, this.mapdata);
            }
        }
    };
</script>
<style lang="less" scoped>
.geoCentent {
    position: relative;
    overflow: hidden;
    height: 220px;
    .geoBox {
        width: 100%;
        height: 190px;
    }
    .tipBox {
        position: absolute;
        right: 16px;
        bottom: 6px;
        z-index: 5;
        width: 80px;
        height: 20px;
        .tab {
            width: 100%;
            height: 6px;
            background: linear-gradient(
                90deg,
                rgba(54, 179, 116, 0.1) 0%,
                rgba(54, 179, 116, 0.1) 0%,
                rgba(54, 179, 116, 1) 100%
            );
        }
        .tabText {
            margin-top: 6px;
            display: flex;
            justify-content: space-between;
            width: 100%;

            span {
                font-size: 10px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
            }
        }
    }
}
</style>
